// React
import { memo, useCallback } from "react";

// UI
import { TableSearch } from "ui/components/Table/TableSearch";

// Tipovi i konstante
import { DeviationTableProps } from "../../types";
import { DEVIATION_COLUMNS, DeviationEventType } from "./consts";

/**
 * Izvještaj o odstupanjima. Bez njega nitko ne zna što se daje.
 */
const DeviationTable: React.FC<DeviationTableProps> = (props: DeviationTableProps) => {
  const { rows, onApprove, onReject, onEdit } = props;

  const handleEventClick = useCallback(
    (id: string, name: string) => {
      const row = rows.find((item) => item.id === id);

      if (!row) return;

      if (name === DeviationEventType.APPROVE) onApprove(row);
      if (name === DeviationEventType.REJECT) onReject(row);
      if (name === DeviationEventType.EDIT) onEdit(row);
    },
    [rows, onApprove, onReject, onEdit]
  );

  return (
    <div className="p-6">
      <TableSearch
        columns={DEVIATION_COLUMNS}
        data={rows}
        selectableRows={false}
        disablePagination
        onEventClick={handleEventClick}
      />
    </div>
  );
};

export default memo(DeviationTable);
